import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material';
import { ActivatedRoute } from '@angular/router';
import { of } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import { AppService } from 'src/@core/services/app.service';
import { GoogleIntegrationService } from 'src/@core/services/job/google-integration.service';
import { JobService } from 'src/@core/services/job/job.service';
import { NotificationService } from 'src/@core/services/notification.service';
import { ThemeService } from 'src/@core/services/theme.service';
import { CallAgentComponent } from 'src/app/modules/agents/call-agent/call-agent.component';
import { EnterpriseAdminService } from 'src/app/modules/enterprise-admin/enterprise-admin.service';
import { CreateLeadsUserComponent } from '../../view-project/create-leads-user/create-leads-user.component';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'hour4u-admin-view-search',
  templateUrl: './view-search.component.html',
  styleUrls: ['./view-search.component.scss']
})
export class ViewSearchComponent implements OnInit {
  searchProjectName: any = null;
  callData: any = null;
  projectDetails: any;
  metadata: any;
  pagination: any;
  pageIndex: number = 1;
  pageSize: number = 10;
  pageSizeOptions: number[] = [10, 20, 50, 100, 200, 500];
  currentRange: string = '';
  diameter = 40;
  loaderColor: string;
  mode = 'indeterminate';
  isLoading: boolean = false;
  profile = this.appService.getCurrentAccount();
  dataSource = [];
  googleTokenExpired: boolean = false;
  CLIENT_ID: string = environment.googleClientId;
  projectId: any = null;

  constructor(
    public themeService: ThemeService,
    public enterpriseAdminService: EnterpriseAdminService,
    private appService: AppService,
    private jobService: JobService,
    private googleIntegrationService: GoogleIntegrationService,
    private notify: NotificationService,
    private route: ActivatedRoute,
    private dialog: MatDialog
  ) { }

  ngOnInit() {
    this.route.params.subscribe(result => {
      console.log("data---", result);
      this.projectId = result.id;
      this.getProjectById(this.profile.entity.id, this.projectId)
    })
  }

  getProjectById(entityId: string, projectId: string) {
    console.log('project details retrieved successfully:');

    this.jobService.getProjectById(entityId, projectId).pipe(
      switchMap((projectDetails) => {
        console.log('Project details retrieved successfully:', projectDetails);
        this.projectDetails = projectDetails;
        this.getAllCalls();

        // Check if google_calendar_token exists before making the API call
        if (!projectDetails.google_calendar_token) {
          throw new Error('No Google Calendar token available.');
        }

        // Call the Google API and handle only its errors separately
        return this.googleIntegrationService.validateToken({ "refresh_token": projectDetails.google_calendar_token }).pipe(
          catchError(error => {
            console.error('Google API Error:', error);
            this.notify.showMessage(
              'Please reconnect your google calendar for scheduling meetings!',
              10000
            );
            this.googleTokenExpired = true;
            return of(null); // Return a fallback value to prevent the observable chain from breaking
          })
        );
      })
    ).subscribe(
      (data) => {
        if (data) {
          console.log('Google API response:', data);
        }
      },
      (error) => {
        console.error('Error:', error);
        // Handle only non-Google API errors here
      }
    );

    // this.jobService.getProjectById(entityId, projectId).subscribe(
    //   (response) => {
    //     console.log('Project details retrieved successfully:', response);
    //     this.projectDetails = response;
    //     this.getAllCalls();
    //   },
    //   (error) => {
    //     console.error('Failed to fetch project details:', error);
    //   }
    // );
  }

  private getAllCalls() {
    this.dataSource = [];
    this.getDBCallsHistory(this.pageSize, this.pageIndex);
  }

  getDBCallsHistory(maxPageSize: number, pageNum: number) {
    this.isLoading = true;
    this.enterpriseAdminService.getCallHistoryProject(this.profile.entity.id, this.projectDetails.project_id, maxPageSize, pageNum).subscribe(res => {
      this.isLoading = false;
      if (res && res.records && res.records.length) {
        this.dataSource = res.records;
        this.pagination = res.pagination;
        this.metadata = res.metadata;
        console.log(this.metadata)
        this.dataSource.forEach(ele => {
          if (ele.start_time) {
            ele.start_time = this.formatStartTime(ele.start_time);
          }
        })
        this.callData = res;
        console.log(this.dataSource);
      }
    }, (err => {
      this.isLoading = false;
      console.log(err);
    }))
  }

  formatStartTime(value: any): string {
    const timestamp = parseFloat(value) * 1000; // Convert to milliseconds
    const date = new Date(timestamp);

    // Get the day, month, and year
    const day = date.getDate();
    const month = this.getMonthAbbreviation(date.getMonth()); // Get month abbreviation (e.g., "Dec")
    const year = date.getFullYear();

    // Get the time components (hours, minutes, seconds)
    const hours = date.getHours();
    const minutes = date.getMinutes();
    const seconds = date.getSeconds();

    // Format time in 12-hour format with AM/PM
    const period = hours >= 12 ? 'PM' : 'AM';
    const formattedHours = hours % 12 || 12;
    const formattedMinutes = this.padNumber(minutes);
    const formattedSeconds = this.padNumber(seconds);

    // Return formatted string like 'Dec 31, 2024, 5:04:39 PM'
    return `${month} ${day}, ${year}, ${formattedHours}:${formattedMinutes}:${formattedSeconds} ${period}`;
  }

  // Helper method to get month abbreviation (e.g., 'Jan' for January)
  getMonthAbbreviation(month: number): string {
    const months = [
      'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
      'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
    ];
    return months[month] || '';
  }

  // Helper method to pad single digits for minutes and seconds
  padNumber(num: number): string {
    return num < 10 ? `0${num}` : `${num}`;
  }

  onPageChange(event: { pageNum: number; pageSize: number }) {
    const { pageNum, pageSize } = event;
    this.pageIndex = pageNum;
    this.pageSize = pageSize;
    console.log('Page Number:', pageNum, 'Page Size:', pageSize);
    this.getDBCallsHistory(this.pageSize, this.pageIndex);
  }

  searchLeads() {

  }

  clearSearch() {

  }

  importFromCSV() {
    const dialogRef = this.dialog.open(CallAgentComponent, {
      panelClass: 'add-edit-staff-dialog',
      disableClose: true,
      autoFocus: true,
      minWidth: "500px",
      data: {
        projectId: this.projectDetails.project_id
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      console.log(result)
      if (result) {
        this.getAllCalls();
      }
    });
  }

  addUserManually() {
    const dialogRef = this.dialog.open(CreateLeadsUserComponent, {
      panelClass: 'create-lead-dialog',
      disableClose: true,
      autoFocus: true,
      width: '560px',
      maxWidth: '95vw',
      data: {
        project_id: this.projectDetails.project_id
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      console.log(result)
      if (result) {
        this.getAllCalls();
      }
    });
  }

}
